<div class="tabs-bg text-left">
  <div class="tabs-bg__wrap">
    <ng-content></ng-content>
  </div>
</div>
